export default __webpack_public_path__ + "static/media/border-3.acdd3b50.png";